import React from 'react';

export default function VideoPlayer() {
  return (
    <div className="appContainer">
      <section className="heroSection">
        <h1>Video Player</h1>
        <p>Watch and upload videos to a shared platform</p>
        <a href="https://github.com/cmiller12312/VideoPlayer" className="ctaButton" target="_blank" rel="noopener noreferrer">
          View Source Code
        </a>
      </section>

      <section className="projectsSection">
        <h2>Project Overview</h2>
        <p>
          A video program that lets users watch and upload mp4 files to a channel. As well as some other features such as downloading videos and such.
        </p>

        <div style={{ margin: '40px 0', textAlign: 'center' }}>
          <video width="100%" controls style={{ maxWidth: '800px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.2)' }}>
            <source src="/videoPlayer.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <h2>Key Features</h2>
        <ul className="skillsList">
          <li> Basic user interface with login and account personalization</li>
          <li> tools to upload videos to your account </li>
          <li> menu to watch videos made by others</li>
          <li> following and view counts for each user/video</li>
        </ul>

        <h2 style={{ marginTop: '40px' }}>Tech Stack</h2>
        <ul className="skillsList">
          <li><strong>Django</strong> — Backend Development</li>
          <li><strong>Electron</strong> — Desktop Application Frontend</li>
          <li><strong>HTML & CSS</strong> — Responsive UI Styling</li>
        </ul>


        <h2 style={{ marginTop: '40px' }}>Additional Info</h2>
        <p>
          This project was made for learning reasons to help me better understand what goes into making a software and it did just that. This program taught me what works and what doesnt.
        </p>

        <h2 style={{ marginTop: '40px' }}>What was learned</h2>
        <p>
          Throughout this project I learned quite a few things. For starters, I learned that making a Python subprocess is not the best idea for software design. While it works, it's not as fast and ultimately unneeded—especially since React with its tools can accomplish pretty much the same thing that I used the subprocess for. During the design process it didn’t occur to me that I could not only expose the routes on the server but could also expose static files like images.

My program shows this as I send over the profile pictures (pfps) via HTTP and then write them to the stdout from the Python subprocess so the main program could use it. I could’ve avoided this entirely by exposing all of the images on the Django server. I learned this about halfway through the project, so it can be seen being utilized for videos and such to avoid making it slower than needed. On that note, I exposed the videos via Django, but in production I would not do this and instead would use a reverse proxy to handle images and videos. This is because doing it the way I did can work, but it clogs the Django server in real-world use.

This was my first time using Electron in a project, and I learned how powerful of a tool it can be for making desktop apps. For future projects I intend to combine React with Electron to make powerful frontend programs. This project taught me how to utilize Django’s features better as well. I got a better understanding of not only how REST frameworks work but also a better understanding of how to implement user authentication.

Overall, this program helped me get a better grasp on the design process for software and helped me better understand what is good practice and bad practice. This project gets me excited to make new projects to one-up myself with what I’ve learned.
        </p>
      </section>

      <footer className="footerSection">
        Built by Cale Miller
      </footer>
    </div>
  );
}
